/* eslint-disable react/prefer-stateless-function */
/**
 * The HOC is used to filter out specific records that pass predicate. It's based on Lodash _.filter()
 * @author: Ronan
 * @param: sourceDataProp {string} prop as a source to filter
 * @param: filterFunc {function} function that filter out on value
 * @param: targetDataProp {string} OPTIONAL prop name to be attached to wrapped component
 */
import React, { Component } from 'react';

const filterBy = (sourceDataProp, filterFunc, targetDataProp = 'filteredData') => WrappedComponent => (class extends Component {
  state = { filterText: '' }

  // TODO: think how to separate this part. Because some component will return event object, but some will return value itself
  //       Temporarily we use for input field only
  handleFilterChange = newVal => this.setState({ filterText: newVal })

  render() {
    const { filterText } = this.state;
    const sourceData = _.isArray(this.props[sourceDataProp]) ? this.props[sourceDataProp] : [];
    const predicate = (record, i, collection) => filterFunc(record, i, collection, filterText);
    const props = {
      ...this.props,
      filterText,
      handleFilterChange: this.handleFilterChange,
      [targetDataProp]: _.filter(sourceData, predicate),
    };

    return <WrappedComponent {...props} />;
  }
});

export default filterBy;



// WEBPACK FOOTER //
// ./src/components/hoc/filterBy.jsx